import { render } from "./CheckoutControls.vue?vue&type=template&id=167ded46&scoped=true"
import script from "./CheckoutControls.vue?vue&type=script&lang=js"
export * from "./CheckoutControls.vue?vue&type=script&lang=js"

import "./CheckoutControls.vue?vue&type=style&index=0&id=167ded46&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-167ded46"]])

export default __exports__
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QIcon,QBtn});
